export default "__VITE_ASSET__RUd8Yp5h__"